/**
 * Disinformation Analysis Demo Page
 * Standalone page to demonstrate the agent analysis with progressive updates
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { AgentAnalysis } from '../components/AgentAnalysis';
import type { AnalysisResponse } from '../services/agent.service';

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
`;

const Header = styled.header`
  padding: 24px 48px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const Logo = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: white;

  span {
    color: #3b82f6;
  }
`;

const Subtitle = styled.p`
  margin: 8px 0 0;
  font-size: 14px;
  color: #94a3b8;
`;

const MainContent = styled.main`
  padding: 32px 48px;
  max-width: 1400px;
  margin: 0 auto;
`;

const ContentCard = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

const DisinformationDemo: React.FC = () => {
  const { t } = useTranslation();
  const handleAnalysisComplete = (result: AnalysisResponse) => {
    console.log('Analysis completed:', result);
  };

  return (
    <PageContainer>
      <Header>
        <Logo>
          didi <span>{t('demo.title')}</span>
        </Logo>
        <Subtitle>
          {t('demo.subtitle')}
        </Subtitle>
      </Header>

      <MainContent>
        <ContentCard>
          <AgentAnalysis onAnalysisComplete={handleAnalysisComplete} />
        </ContentCard>
      </MainContent>
    </PageContainer>
  );
};

export default DisinformationDemo;
